module.exports = " <div class=\"map\" id=\"map\"></div> <div id=\"mouse-position\"></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-geoadmin-map/dv-geoadmin-map.html
// module id = SUmS
// module chunks = 0